<template>
    <div>
        <el-dialog
            title="Восстановление пароля"
            :visible.sync="forgotVisible"
            width="356px"
        >
            <div>
                <el-form class="m-t-10" ref="forgotForm" :model="forgotModel">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="Введите логин" prop="Login" :rules="[{ required: true, message: 'Данные обязательны для заполнения' }]">
                                <el-input v-model="forgotModel.Login" placeholder="Логин/номер карты/гос.номер авто"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="p-b-10  m-t-30">
                    <el-row :gutter="20">
                        <el-col :span="12" align="left" class="d-flex align-items-left">
                            <el-button class="m-l-20" type="link" @click="forgotVisible = false">Закрыть</el-button>
                        </el-col>
                        <el-col :span="12" align="right" class="d-flex align-items-right">
                            <el-button type="primary" class="w-100" @click="changePassword" :loading="loadingForgot">Восстановить</el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>

        <div class="page-auth">
            <div v-if="autoAuth && this.$route.query.user && this.$route.query.password" class="auth-wrapper">
                <img src="~assets/img/logo.png" />
            </div>
            <div>
                <h1>Требуется авторизация</h1>
                <el-form :model="form" ref="form" status-icon label-width="0" >
                    <div class="errMsg_wrapper">
                        <div class="errMsg" v-html="err"></div>
                    </div>
                    <el-form-item label="" prop="login" :rules="[{ required: true, message: 'Введите логин' }]">
                        <el-input id="login" v-model="form.login" name="login" placeholder="Логин" autocomplete="on">
                            <template slot="append"><i class="fa fa-user"></i></template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="" prop="password">
                        <el-input id="password" type="password" v-model="form.password" name="password" auto-complete="off" placeholder="Пароль">
                            <template slot="append"><i class="fa fa-unlock-alt"></i></template>
                        </el-input>
                    </el-form-item>
                    <el-button type="primary" v-on:click="login" class="m-t-30 w-100">Войти</el-button>
                    <el-button type="link" v-on:click="forgotVisible = true" class="m-t-20 w-100" style="margin-left: 0;">Забыли пароль?</el-button>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form: {
                    login: '',
                    password: ''
                },
                rules: {
                    login: [
                        { required: true, message: 'Введите логин', trigger: 'blur' }
                    ]
                },
                autoAuth: false,
                err: '',
                forgotVisible: false,
                loadingForgot: false,
                forgotModel: {
                    Login: ''
                }
            }
        },
        mounted () {
            console.log("Загружена форма логина")

            if (this.$route.query.token) {
                console.log("Получен токен, редирект на главную")
                sessionStorage.setItem('token', this.$route.query.token)
                this.$router.push('/')
            }
            if (this.$route.query.user && this.$route.query.password) {
                console.log("Получены логин/пароль")
                this.form.login = this.$route.query.user
                this.form.password = this.$route.query.password
                this.login()
            }
        },
        methods: {
            login: function () {
                console.log("Авторизуемся")
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.clearFormErrors('form')

                        let request = {
                            Name: 'Login',
                            OperatorName: this.form.login,
                            OperatorPassword: this.form.password
                        }
                        this.$store.dispatch('Login', request).then(() => {

                            let config = JSON.parse(sessionStorage.getItem('config'))
                            if (config && config.discountApi) {

                                let bodyDiscounts = {
                                    "Name": "Login",
                                    "Version": "1.2",
                                    "HardwareId": null,
                                    "User": this.form.login,
                                    "Password": this.form.password
                                }
                                console.log("Авторизуемся в Discounts")
                                this.$api.Discounts.login(bodyDiscounts).then(response => {
                                    console.log("Авторизовались в Discounts")
                                    console.log(response)
                                    if (response.SessionIdAsString) sessionStorage.setItem('sessionId', response.SessionIdAsString)
                                    sessionStorage.setItem('username', this.form.login)
                                    this.continueLogin()
                                })
                            }
                            else {
                                sessionStorage.setItem('username', this.form.login)
                                this.continueLogin()
                            }
                        })
                        .catch(err => {
                            this.autoAuth = false
                            this.err = err
                            console.log(err)
                        })
                    }
                })
            },
            continueLogin () {
                console.log("Получаем основные сущности")
                this.$api.Main.getTarif().then(response => {
                    sessionStorage.setItem('tarifDict', JSON.stringify(response.Items))
                    this.$api.Main.getCustomerGroup().then(response => {
                        sessionStorage.setItem('customerGroupDict', JSON.stringify(response.Items))
                        this.$api.Main.getZones1().then(response => {
                            sessionStorage.setItem('zonesDict', JSON.stringify(response.Items))
                            console.log("Все получили, редиректим на главную")

                            window.location.href = "/"
                            // this.$router.push('/')
                        })
                    })
                })
            },
            changePassword () {
                this.$refs['forgotForm'].validate((valid) => {
                    if (valid) {
                        this.clearFormErrors('forgotForm')

                        let request = {
                            Name: 'GenerateTempPassword',
                            OperatorName: this.forgotModel.Login,
                        }
                        this.$api.Auth.generateTempPassword(request).then(response => {
                            if (response.Result === "Success") {
                                this.$message({ message: 'Письмо с временным паролем отправлено на E-mail, привязанный к логину', type: 'success', res: response })
                                this.forgotVisible = false
                                this.forgotModel.Login = ''
                            }
                            else {
                                this.$message({ message: response.ErrorString, type: 'error', res: response })
                            }
                        })
                        .catch(err => {
                            this.err = err
                            console.log(err)
                        })
                    }
                })
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
